// TODO: переделать на функцию из набора ACCEPTS (их пока нет)
/**
 * Очищает строку от всего, что не может содержать email
 */
export const getEmailCharsFromStr = (value?: string): string =>
    value ? value.replace(/[^\w-.@]+/g, '') : '';
